import {mapGetters} from 'vuex';

export const UacMixins = {
  computed: {
    ...mapGetters([
      'authUser',
    ]),

    isStaff() {
      return this.authUser.scope == 'STAFF';
    },


    isSystemAdmin(){
      if(this.isStaff){
        return this.authUser.position.some(pos=>pos['id']===1);
      }
      return false
    },

    isPrincipalAdmin(){
      if(this.isStaff){
        return this.authUser.position.some(pos=>pos['id']===2);
      }
      return false
    },

    isPrincipal(){
      if(this.isStaff){
        return this.authUser.position.some(pos=>pos['id']===3);
      }
      return false

    },

    isManningAdmin(){
      if(this.isStaff){
        return this.authUser.position.some(pos=>pos['id']===4);
      }
      return false

    },

    isManningStaff(){
      if(this.isStaff){
        return this.authUser.position.some(pos=>pos['id']===5);
      }
      return false
    },

    isScheduler(){
      if(this.isStaff){
        return this.authUser.position.some(pos=>pos['id']===6);
      }
      return false
    },

    isPrincipalStaff(){
      if(this.isStaff){
        return this.authUser.position.some(pos=>pos['id']===8);

      }
      return false

    },

    isAssistantScheduler(){
      if(this.isStaff){
        return this.authUser.position.some(pos=>pos['id']===9);

      }
      return false
    },


    userPosition() {
      if(this.isStaff){
        return this.authUser.position.map((pos) => {
          return pos.short_name;
        }).join(' / ');
      }
      else{
        return this.authUser.position.short_name
      }
    },

    userFullName() {
      return this.authUser.full_name;
    },

    hasRagAccess(){
      return [1,70,119, 157, 158, 159, 160, 161, 188, 199, 201,219, 358,302,594,322,632,363,322,292,416,298,579,533,312,331].includes(this.authUser.id)
    }
  },

};
